import {
  DashboardOutlined,
  MessageOutlined,
  SafetyOutlined,
  ShoppingCartOutlined,
  UnlockOutlined,
  HistoryOutlined,
  AuditOutlined,
  PlusSquareOutlined,
  UserAddOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";

const dashBoardNavTree = [
  {
    title: "Menu",
    icon: ShoppingCartOutlined,
    breadcrumb: false,
    submenu: [
      {
        key: "home",
        path: `${APP_PREFIX_PATH}/bidding`,
        title: "Subasta",
        icon: ShoppingCartOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "account",
        path: `${APP_PREFIX_PATH}/setting`,
        title: "Mi Cuenta",
        icon: UnlockOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "history",
        path: `${APP_PREFIX_PATH}/history`,
        title: "Historial",
        icon: HistoryOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "transaction",
        path: `${APP_PREFIX_PATH}/history`,
        title: "Transacciones",
        icon: AuditOutlined,
        breadcrumb: false,
        submenu: [
          {
            key: "sold-bid",
            path: `${APP_PREFIX_PATH}/bought`,
            title: "Compras",
            icon: AuditOutlined,
            breadcrumb: false,
            submenu: [],
          },
          {
            key: "bought-bid",
            path: `${APP_PREFIX_PATH}/sold`,
            title: "Ventas",
            icon: AuditOutlined,
            breadcrumb: false,
            submenu: [],
          },
        ],
      },
      {
        key: "chat",
        path: `${APP_PREFIX_PATH}/chat`,
        title: "Chat",
        icon: MessageOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "create",
        path: `${APP_PREFIX_PATH}/create-bid/new`,
        title: "Crear Subasta",
        icon: PlusSquareOutlined,
        breadcrumb: false,
        submenu: [],
      },
      // {
      //   key: 'create-user',
      //   path: `${APP_PREFIX_PATH}/user-creator`,
      //   title: 'Crear Usuario',
      //   icon: UserAddOutlined ,
      //   breadcrumb: false,
      //   submenu: []
      // },
      {
        key: "user-list",
        path: `${APP_PREFIX_PATH}/users`,
        title: "Usuarios",
        icon: UserAddOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "logs",
        path: `${APP_PREFIX_PATH}/logs`,
        title: "Ver logs",
        icon: FileTextOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
